import type { DocumentType } from "../../domain/entities/document"

const TYPE_LABEL: Record<DocumentType, string> = {
  pdf: "PDF",
  doc: "DOC",
  text: "TEXT",
  image: "IMAGE",
  tabular: "TABULAR",
}

export const TypeBadge = ({ type }: { type: DocumentType }) => (
  <span className="inline-flex items-center rounded-full border border-border bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground">
    {TYPE_LABEL[type]}
  </span>
)
